import React, { useEffect, useReducer, useState, useRef } from "react";
import { hot } from "react-hot-loader/root";
import { Col, ListGroup, Tab, Row } from "react-bootstrap";
import SmsDashboardReducer from "./SmsDashboardReducer";
import Switch from '@mui/material/Switch';
import FormGroup from '@mui/material/FormGroup';
import Button from '@mui/material/Button';
import * as Yup from "yup";
import FormControlLabel from '@mui/material/FormControlLabel';
import {
  MdClose,
  MdSearch,
  MdAccountCircle,
  MdOutbox,
  MdInbox,
  MdAddCall,
  MdSort
} from "react-icons/md";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Grid } from '@mui/material';
import Paper from '@mui/material/Paper';
import { useFormik } from 'formik';
import MessageIcon from '@mui/icons-material/Message';
import * as API from "../api/SmsApi";
import * as SmsChannel from "../channels/sms_channel";
import * as CONST from "./sms-dashboard/Constants.js";
import PendingChatThread from "./sms-dashboard/PendingChatThread.js";
import SendIcon from '@mui/icons-material/Send';
import ChatThread from './sms-dashboard/ChatThread';
import ChatIcon from '@mui/icons-material/Chat';

function setUpCallChannelSubscription(settings, stateRef, events) {
  SmsChannel.createSmsSubscription(
    settings,
    stateRef,
    events
  );
};

function SmsDashboard() {
  let [loading, setLoading] = useState(false);
  let [settings, setSettings] = useState(null);
  const [state, dispatch] = useReducer(SmsDashboardReducer, CONST.INIT_STATE);
  const stateRef = useRef(state);
  let [currentTextMessageThread, setCurrentTextMessageThread] = useState(
    stateRef.current && stateRef.current.text_message_thread ?
      stateRef.current.text_message_thread : null
  );
  let [pendingTextMessageThreads, setPendingTextMessageThreads] = useState(null);
  let [currentTextMessageThreadId, setCurrentTextMessageThreadId] = useState(null);
  let [showNewTextThread, setShowNewTextThread] = useState(false);
  let [receivedTextThread, setReceivedTextThread] = useState(false);
  let [textMessageThreads, setTextMessageThreads] = useState(stateRef.current ? stateRef.current.text_message_threads : null);
  const [submitting, setSubmitting] = useState(false);
  const [loadingThread, setLoadingThread] = useState(false);
  let [receivedTextMessageThreadId, setReceivedTextMessageThreadId] = useState(null);

  const SOCKET_EVENTS = {
    'sms-created': {
      event_type: 'sms-created',
      handler: (xhr) => {
        let currentState = stateRef.current;
        let threadExistsInAgentQueue = currentState.text_message_threads.find((el) => {
          return el.id == xhr.text_message_thread_id;
        }) != null;
        let incomingMessageIsInCurrentThread = currentState.text_message_thread &&
          currentState.text_message_thread.id == xhr.text_message_thread_id;
        let currentTmt = currentState.text_message_thread;
        setSubmitting(false);

        if(xhr.from_wellportal != true) {
          if (threadExistsInAgentQueue) {
            if (incomingMessageIsInCurrentThread) {
              currentTmt['text_messages'].push(xhr);
              dispatch({
                type: "set_current_text_message_thread",
                text_message_thread: currentTmt,
              });
            } else {
              setReceivedTextMessageThreadId(xhr.text_message_thread_id);
            }

            // text message thread received, but not in current agent's queue
            // then display receivedTextMessageThread
          } else {
            setReceivedTextThread(xhr);
          }


          // if FROM wellportal
        } else {

          if (!threadExistsInAgentQueue) {

            // basically when support agent picks up pending thread.
            if (incomingMessageIsInCurrentThread) {
              currentState.text_message_threads.unshift(xhr);
              setTextMessageThreads(currentState.text_message_threads);
            } else {
              setCurrentTextMessageThreadId(xhr['id']);
              fetchTextMessageThread(xhr['text_message_thread_id']);
            }
          // thread does exist in agent queue, message from WP Agent
          } else {

            if (incomingMessageIsInCurrentThread) {
              let currentTmt = currentState.text_message_thread;
              currentTmt['text_messages'].push(xhr);
              dispatch({
                type: "set_current_text_message_thread",
                text_message_thread: currentTmt,
              });
            } else {
              setReceivedTextMessageThreadId(xhr.text_message_thread_id);
            }
          }
        }
      }
    }
  };

  // Update the ref whenever state changes
  useEffect(() => {
    stateRef.current = state;
  }, [state]);

  useEffect(() => {
    setLoading(true);

    const fetchData = async () => {
      let response = await API.getSmsData();
      if (response) {
        let responseData = response.data;
        setLoading(false);
        setSettings(responseData['settings']);
        setTextMessageThreads(responseData['text_message_threads']);
        setPendingTextMessageThreads(responseData['pending_text_message_threads']);
        dispatch({
          type: "set_text_message_threads",
          text_message_threads: responseData['text_message_threads'],
          pending_text_message_threads: responseData['pending_text_message_threads'],
          settings: responseData['settings']
        });
        SmsChannel.createSmsSubscription(
          responseData['settings'],
          stateRef,
          SOCKET_EVENTS
        );
      }
    };
    if(textMessageThreads == null) {
      fetchData();
    }
  }, []);

  const fetchTextMessageThread = async (textMessageThreadId) => {
    setCurrentTextMessageThread(null);
    setShowNewTextThread(null);
    setLoadingThread(true);
    setCurrentTextMessageThreadId(textMessageThreadId);
    setReceivedTextMessageThreadId(null);
    let threadExistsInAgentQueue = stateRef.current.text_message_threads.find((el) => {
      return el.id == textMessageThreadId;
    }) == null;
    let response = await API.getTextMessageThread(textMessageThreadId);
    if (response) {
      setCurrentTextMessageThread(response.data);

      // if text message threads on the state does not have this incoming text message thread,
      // make sure you set it.
      if (threadExistsInAgentQueue) {
        stateRef.current.text_message_threads.unshift(response.data);
        setTextMessageThreads(stateRef.current.text_message_threads);
      }
      setLoadingThread(false);
      dispatch({
        type: "set_current_text_message_thread",
        text_message_threads: stateRef.current.text_message_threads,
        text_message_thread: response.data
      });
    }
  }

  const NewChatThread = (submitting, textMessageThreads) => {
    const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

    const TextMessageThreadSchema = Yup.object().shape({
      body: Yup.string().required("Body is required").
        min(2, "Minimum 2 number characters or more"),
      phone_number:  Yup.string().required("Phone Number field is required").
        min(10, 'Must be exactly 10 digits').
        max(10, 'Must be exactly 10 digits').
        matches(phoneRegExp, 'Phone number is not valid')
    });

    const handleSubmit = async (values) => {
      setSubmitting(true);
      setShowNewTextThread(false);
      let response = await API.postTextMessageThread({
        'body': values.body,
        'phone_number': values.phone_number
      });
    };

    const formik = useFormik({
      initialValues: {
        phone_number: '',
        body: '',
      },
      validationSchema: TextMessageThreadSchema,
      onSubmit: handleSubmit,
    });

    return(
      <Paper elevation={1} id='new-text-thread-container'>
        <div id='new-text-thread-header'>
          <MessageIcon /> Send Text Message
        </div>
        <div>
          <form
            onSubmit={formik.handleSubmit}
          >
            <div className='text-message-thread-form'>
              <label className='full-width'>
                <input
                  type='text'
                  name='phone_number'
                  placeholder='Phone Number'
                  className={'full-width'}
                  style={{ fontWeight: 'lighter' }}
                  value={formik.values.phone_number}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.phone_number && formik.errors.phone_number && (
                  <div className="form-error error">{formik.errors.phone_number}</div>
                )}
              </label>
              <label className='full-width'>
                <textarea
                  className={'full-width'}
                  style={{ fontWeight: 'lighter' }}
                  name='body'
                  value={formik.values.body}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  id={'new-text-message-body-container'}
                >
                </textarea>
                {formik.touched.body && formik.errors.body && (
                  <div className="form-error error">{formik.errors.body}</div>
                )}
              </label>
              <br />
              <button type='submit'>
                <SendIcon /> Send
              </button>
            </div>
          </form>
        </div>
      </Paper>
    )
  };

  return loading ? (
    <div className='container'>
      <div className='panel'>
        <div className='panel-body'>
          <h3 style={{ textAlign: 'center' }}><i className='fa fa-spinner fa-spin'></i> Loading..</h3>
        </div>
      </div>
    </div>) : (<>
    <div className='container'>
      <div className='panel'>
        <div className='panel-body'>
          <h2><ChatIcon sx={{fontSize: '1.2em'}}/>  wellPORTAL SMS Center</h2>
          <div className='description text-center'>
            Respond to incoming text messages from patients in this dashboard.
            <br />
            You are currently logged in.
            <br />
            You have <b>{ settings ? settings.threads_count : (<i className='fa fa-spinner fa-spin' />) } threads</b> you have texted in.
            <br />
            {receivedTextThread && (<>
              <div
                onClick={(el) => {
                  setReceivedTextThread(null);
                  fetchTextMessageThread(receivedTextThread['text_message_thread_id']);
                }}
                className={'received-text-thread-component flash'}
              >
                New Text Message from <b>{ receivedTextThread['patient'] || receivedTextThread['from'] }</b>!
                <br />
                <b> Click to open thread! </b>
              </div>
            </>)}

            <br />
            <Paper sx={{ height: 'auto', width: '100%', overflow: 'hidden' }}>
              <Grid container direction="row">
                <Grid item xs={12} sm={6} pt={1} pr={1}>
                  <TableContainer>
                    <h3><ChatIcon /> Pending Threads</h3>
                    <div className='description'>
                      Threads have not been responded to.
                    </div>
                    <Table stickyHeader className="table m-t-lg">
                      <TableHead>
                        <TableRow>
                          <TableCell>Phone Number</TableCell>
                          <TableCell>Patient</TableCell>
                          <TableCell>Last Sent At</TableCell>
                          <TableCell>Text Messages</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {
                          pendingTextMessageThreads ? (<>
                            { pendingTextMessageThreads.map((el) => {
                                return (
                                  <PendingChatThread
                                    key={el.id}
                                    pendingTextMessageThreads={pendingTextMessageThreads}
                                    fetchTextMessageThread={fetchTextMessageThread}
                                    setPendingTextMessageThreads={setPendingTextMessageThreads}
                                    thread={el}
                                  />);
                              })
                            }
                          </>) : ''
                        }
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
                <Grid item xs={12} sm={6} pt={1} pl={1}>
                  <TableContainer>
                    <h3><ChatIcon /> My Threads</h3>
                    <div className='description'>
                      Threads which you have sent text messages in.
                    </div>
                    <Table stickyHeader sx={{ overflow: 'scroll' }} className="table m-t-lg">
                      <TableHead>
                        <TableRow>
                          <TableCell>Phone Number</TableCell>
                          <TableCell>Patient</TableCell>
                          <TableCell>Last Sent At</TableCell>
                          <TableCell>Text Messages</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {
                          textMessageThreads ? (<>
                            { textMessageThreads.map((el) => {
                                return (
                                  <PendingChatThread
                                    key={el.id}
                                    pendingTextMessageThreads={textMessageThreads}
                                    fetchTextMessageThread={fetchTextMessageThread}
                                    thread={el}
                                  />);
                              })
                            }
                          </>) : ''
                        }
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              </Grid>
            </Paper>
          </div>
        </div>
      </div>
    </div>
    <div className={'sms-dashboard-bottom-container'}>
      <div
        onClick={(el) => {
          setCurrentTextMessageThread(null);
          setShowNewTextThread(!showNewTextThread);
        }}
        className={showNewTextThread == true ? 'selected' : ''}
        id='text-patient-btn'
      >
        <MessageIcon /> <span style={{ verticalAlign: 'top', fontWeight: 'bold'}}>New Text</span>
      </div>
      {
        textMessageThreads && (
            textMessageThreads.map((el, id) => {
              return (
                <>
                  <div
                    key={id}
                    className={`text-message-thread-btn ${receivedTextMessageThreadId == el.id ? 'flash' : ''} ${ currentTextMessageThread && el.id == currentTextMessageThread.id ? 'selected' :'' }`}
                    onClick={() => fetchTextMessageThread(el.id)}
                  >
                    { el.patient_name || el.phone_number }
                    { loadingThread == true && currentTextMessageThreadId == el.id && (<i style={{ marginLeft: '3px', color: '#2cb5fa' }} className='fa fa-spinner fa-spin' />) }
                  </div>
                </>
              );
            })
        )
      }
    </div>

    { showNewTextThread == true && <NewChatThread submitting={submitting} textMessageThreads={textMessageThreads} /> }

    {
      currentTextMessageThread && (
        <>
          <div className='chat-threads-container'>
            <ChatThread
              phoneNumber={currentTextMessageThread.phone_number}
              textMessageThreadId={currentTextMessageThread.id}
              patient_uid={currentTextMessageThread.patient_uid}
              header={currentTextMessageThread.patient_name || currentTextMessageThread.phone_number}
              onClose={(el) => setCurrentTextMessageThread(null) }
              support_agent_name={stateRef.current.settings.support_agent}
              messages={currentTextMessageThread.text_messages}
              healthPlan={currentTextMessageThread.patient && currentTextMessageThread.patient.health_plan}
              eligible={currentTextMessageThread.patient && currentTextMessageThread.patient.eligible}
            />
          </div>
        </>
      )
    }

  </>)
};

export default hot(SmsDashboard);
